(function () {
  function initPolicyPage(section) {
    if (section.dataset.policyInit) return;
    section.dataset.policyInit = 'true';

    var links = Array.prototype.slice.call(section.querySelectorAll('.policy-page__toc-link'));
    var articles = Array.prototype.slice.call(section.querySelectorAll('.policy-page__section'));
    if (!links.length || !articles.length) return;

    var linkById = {};
    links.forEach(function (link) {
      linkById[link.dataset.target] = link;

      link.addEventListener('click', function (event) {
        var targetId = link.dataset.target;
        var target = section.querySelector('#' + CSS.escape(targetId));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + targetId);
      });
    });

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.target === id);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
      );
      articles.forEach(function (article) {
        observer.observe(article);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.policy-page').forEach(initPolicyPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
